/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { FeedItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox/Checkbox';
import { Date } from '../Date/Date';
import { Destination } from '../Destination/Destination';
import { Download } from '../Download/Download';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Publish } from '../Publish/Publish';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface FeedProps extends FeedItemProps {
    checkboxClassname?: string;
}

export const Feed: FC<FeedProps> = (props) => {
    const path = props.home === '/' ? 'Облако' : props.home.slice(0, props.home.length);

    return (
        <>
            <TableColumn>
                <Checkbox className={props.checkboxClassname} onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                <Pic isFolder={props.isFolder} thumbUrl={props.thumbUrl} isVirus={!!props.isVirus} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <Destination destination={path} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.mtime} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Publish onClick={props.onPublish} isShared={props.isPublic} />
                <Download onClick={props.onDownload} ext={props.ext} size={props.size} id={props.id} storage={props.storage} />
            </TableColumn>
        </>
    );
};
